import { translate } from '@jsverse/transloco';
export enum TimeInterval {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
    CUSTOM = 'CUSTOM',
}

export class TimeIntervalHelper {
    static getTimeIntervalLocale(interval: TimeInterval) {
        switch (interval) {
            case TimeInterval.DAY:
                return translate('CORE.DAY');
            case TimeInterval.WEEK:
                return translate('CORE.WEEK');
            case TimeInterval.MONTH:
                return translate('CORE.MONTH');
            case TimeInterval.YEAR:
                return translate('CORE.YEAR');
            case TimeInterval.CUSTOM:
                return translate('CORE.CUSTOM');
            default:
                return interval;
        }
    }
}
